
define('text!templates/modal-header.ejs',[],function () { return '<button type="button" class="close" aria-hidden="true" data-action="cancel">×</button>\n<h5 class="modal-header-title"><%= title %></h5>';});

